import { driver, getInitialStyle } from 'styletron-standard';
import { Provider, createStyled } from 'styletron-react-core';

var styled = createStyled({
  wrapper: function wrapper(Component) {
    return Component;
  },
  getInitialStyle: getInitialStyle,
  driver: driver
});

export { Provider, styled };
export { withStyle, withStyleDeep, withTransform, withWrapper, DebugEngine } from 'styletron-react-core';
//# sourceMappingURL=browser.es5.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/styletron-react/dist/browser.es5.es.js
// module id = 1
// module chunks = 0